import comp from "./BlanksInput";
export default comp;
